<template>
  <div class="component-box">
    <div class="shop-info">
      <img class="shop-photo" :src="shopInfo.logoPath" />
      <div class="shop-show">
        <div class="shop-name">
          {{ shopInfo.name }}
        </div>
        <div
          class="show-info"
          :class="{ active: currentFloorId == 200 }"
          @click="changeCurrent()"
        >
          <span v-if="!!showState[0]"
            >{{ showState[0].name }}
            {{ shopState[showState[0].type] | numberChange }}</span
          >
          <p v-if="!!showState[1]"></p>
          <span v-if="!!showState[1]"
            >{{ showState[1].name
            }}{{ shopState[showState[1].type] | numberChange }}</span
          >
        </div>
      </div>
    </div>

    <div class="shop-btn">
      <i class="el-icon-plus"></i>
      <span>关注</span>
    </div>
  </div>
</template>

<script>
import api from "@/assets/js/api";
// import numberHandler from "../../mixin/numberHandle";
export default {
  name: "ShopCenterAdminWebMShopInfo",
  props: {
    currentFloorId: {
      type: Number,
    },
  },
  data() {
    return {
      shopInfo: {},
      shopState: {},
    };
  },
  // mixins: [numberHandler],
  filters: {
    numberChange: (val) => {
      let number = Number(val);
      if (typeof number !== "number") {
        number = 0;
      }
      if (number >= 10000) {
        number = (Math.floor(number / 1000) / 10).toFixed(1) + "万+";
      }
      return number;
    },
  },
  mounted() {
    this.getShopInfo();
    this.getShopState();
  },
  computed: {
    shopId() {
      return this.$store.state.user.userInfo.shopId;
    },
    showState() {
      return this.$store.state.mDecoration.shopState;
    },
  },
  methods: {
    // 获取店铺信息
    async getShopInfo() {
      const shopInfoResult = await this.$axios.post(
        api.info.getShopInfo + "?shopId=" + this.shopId
      );
      if (shopInfoResult.valid) {
        this.shopInfo = shopInfoResult.result;
        // console.log("this.shopInfo-----", this.shopInfo);
      }
    },
    // 获取店铺数据信息
    async getShopState() {
      const res = await this.$axios.post(api.decoration.getShopState, {
        shopId: Number(this.shopId),
      });
      if (res.valid && res.result) {
        // console.log("this.shopState-----", res.result);
        this.shopState = res.result;
      }
    },
    // 增加选中状态
    changeCurrent() {
      this.$emit("selectFloor", {
        id: 200,
        index: -1,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.component-box {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  height: 55px;
  margin-top: 40px;
  .shop-info {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .shop-photo {
    width: 55px;
    height: 55px;
    border-radius: 55px;
  }
  .shop-show {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    height: 100%;
    width: 200px;
    margin: 0 20px 0 10px;
    .shop-name {
      width: 100%;
      color: #fff;
      font-size: 15px;
      font-style: normal;
      font-weight: 500;
      line-height: 15px;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .show-info {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // width: 100%;
      margin-top: 12px;
      padding: 5px;
      padding-left: 0px;
      color: rgba(255, 255, 255, 0.7);
      font-size: 12px;
      font-style: normal;
      line-height: 12px;
      white-space: nowrap;
      cursor: pointer;
      &:hover {
        padding-left: 5px;
        margin-top: 10px;
        transform: translateX(-5px);
        border-radius: 6px;
        border: 1px dashed #197dff;
        background: #fff;
        box-shadow: 0px 0px 10px 0px rgba(191, 191, 191, 0.25);

        span {
          color: #197dff;
        }
        p {
          background: #bcd9ff;
          opacity: 1;
        }
      }
      // span {
      //   font-size: 22px;
      //   line-height: 11px;
      //   transform: scale(0.5);
      //   transform-origin: left;
      // }
      p {
        width: 1px;
        height: 9px;
        background: rgba(255, 255, 255, 0.7);
        margin: 0 10px;
      }
    }
    .active {
      padding-left: 5px;
      margin-top: 10px;
      transform: translateX(-5px);
      border-radius: 6px;
      border: 1px dashed #197dff;
      background: #fff;
      box-shadow: 0px 0px 10px 0px rgba(191, 191, 191, 0.25);

      span {
        color: #197dff;
      }
      p {
        background: #bcd9ff;
        opacity: 1;
      }
    }
  }
  .shop-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 62px;
    height: 28px;
    transform: translateY(-5px);
    border-radius: 14px;
    border: 1px solid #fff;

    i {
      font-size: 14px;
      font-weight: 700;
      margin-right: 3px;
      color: #fff;
    }

    span {
      color: #fff;
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 13px;
    }
  }
}
</style>
